import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { H5 } from '@liveauctioneers/hammer-ui-core/text';

import PageTitle from '@/components/PageTitle/PageTitle';

import FeaturesPageHeaderMeta from './FeaturesPageHeaderMeta';

const sectionBodyClasses = 'hui-text-body-primary pb-sm text-sm';

const FeaturesPage = () => {
    return (
        <div className="mx-auto max-w-dense px-sm pb-lg">
            <FeaturesPageHeaderMeta />
            <PageTitle title={<FormattedMessage id="features_and_services" />} />
            <div>
                <p className={sectionBodyClasses}>
                    <FormattedMessage id="feature_blurb" />
                </p>

                <H5 className="font-medium">
                    <FormattedMessage id="live_bidding" />
                </H5>
                <p className={sectionBodyClasses}>
                    <FormattedMessage id="live_bidding_blurb" />
                </p>

                <H5 className="font-medium">
                    <FormattedMessage id="absentee_bidding" />
                </H5>
                <p className={sectionBodyClasses}>
                    <FormattedMessage id="absentee_bidding_blurb" />
                </p>

                <H5 className="font-medium">
                    <FormattedMessage id="auctioneer_dashboard" />
                </H5>
                <p className={sectionBodyClasses}>
                    <FormattedMessage id="auctioneer_dashboard_blurb" />
                </p>

                <H5 className="font-medium">
                    <FormattedMessage id="our_network" />
                </H5>
                <p className={sectionBodyClasses}>
                    <FormattedMessage id="our_network_blurb" />
                </p>
                <div className="pb-sm text-center">
                    <img
                        alt="Our network"
                        src="https://images.liveauctioneers.com/static/network.jpg"
                        className="w-full max-w-[700px]"
                    />
                </div>
                <H5 className="font-medium">
                    <FormattedMessage id="catalog_set_up" />
                </H5>
                <p className={sectionBodyClasses}>
                    <FormattedMessage id="catalog_set_up_blurb" />
                </p>

                <H5 className="font-medium">
                    <FormattedMessage id="bidder_management" />
                </H5>
                <p className={sectionBodyClasses}>
                    <FormattedMessage id="bidder_management_blurb" />
                </p>

                <H5 className="font-medium">
                    <FormattedMessage id="inbox_messaging" />
                </H5>
                <p className={sectionBodyClasses}>
                    <FormattedMessage id="inbox_messaging_blurb" />
                </p>

                <H5 className="font-medium">
                    <FormattedMessage id="statistics_tracking" />
                </H5>
                <p className={sectionBodyClasses}>
                    <FormattedMessage id="statistics_tracking_blurb" />
                </p>

                <H5 className="font-medium">
                    <FormattedMessage id="self_service_upload" />
                </H5>
                <p className={sectionBodyClasses}>
                    <FormattedMessage id="self_service_upload_blurb" />
                </p>

                <H5 className="font-medium">
                    <FormattedMessage id="automated_online_console" />
                </H5>
                <p className={sectionBodyClasses}>
                    <FormattedMessage id="automated_online_console_blurb" />
                </p>

                <H5 className="font-medium">
                    <FormattedMessage id="end_of_auction_report" />
                </H5>
                <p className={sectionBodyClasses}>
                    <FormattedMessage id="end_of_auction_report_blurb" />
                </p>

                <H5 className="font-medium">
                    <FormattedMessage id="qr_code" />
                </H5>
                <p className={sectionBodyClasses}>
                    <FormattedMessage id="qr_code_blurb" />
                </p>

                <H5 className="font-medium">
                    <FormattedMessage id="staff_permission_levels" />
                </H5>
                <p className={sectionBodyClasses}>
                    <FormattedMessage id="staff_permission_levels_blurb" />
                </p>

                <H5 className="font-medium">
                    <FormattedMessage id="weekly_newsletter" />
                </H5>
                <p className={sectionBodyClasses}>
                    <FormattedMessage id="weekly_newsletter_blurb" />
                </p>

                <H5 className="font-medium">
                    <FormattedMessage id="help_files" />
                </H5>
                <p className={sectionBodyClasses}>
                    <FormattedMessage id="help_files_blurb" />
                </p>

                <H5 className="font-medium">
                    <FormattedMessage id="bidder_contact_and_invoicing" />
                </H5>
                <p className={sectionBodyClasses}>
                    <FormattedMessage id="bidder_contact_and_invoicing_blurb" />
                </p>

                <H5 className="font-medium">
                    <FormattedMessage id="paypal" />
                </H5>
                <p className={sectionBodyClasses}>
                    <FormattedMessage id="paypal_blurb" />
                </p>

                <H5 className="font-medium">
                    <FormattedMessage id="accounting" />
                </H5>
                <p className={sectionBodyClasses}>
                    <FormattedMessage id="accounting_blurb" />
                </p>

                <H5 className="font-medium">
                    <FormattedMessage id="white_label_platform" />
                </H5>
                <p className={sectionBodyClasses}>
                    <FormattedMessage id="white_label_platform_blurb" />
                </p>
            </div>
        </div>
    );
};

export default FeaturesPage;
